import { useMemo } from 'react';
import { LadderType } from 'feature-components/report-tabs/list-report-tab/types';

export const useTestLadderType = (areaIdentifier: string): LadderType => {
  const ladderType = useMemo(
    () =>
      ['trm', 'stwe', 'jstwe'].includes(areaIdentifier) ? LadderType.Stage : LadderType.Stanine,
    [areaIdentifier]
  );

  return ladderType;
};

export default useTestLadderType;
